import React, { useState, useEffect, useCallback } from "react";
import { X, Sparkles, ClipboardCheck, Minimize2, Maximize2, ShieldCheck, Languages } from "lucide-react";
import { toast } from "sonner";
import * as api from "../api";
import { AiRagiona } from "./AiRagiona";

const MODES = [
  { id: "correggi", label: "Correggi", icon: ClipboardCheck },
  { id: "riduci", label: "Riduci", icon: Minimize2 },
  { id: "espandi", label: "Espandi", icon: Maximize2 },
  { id: "rettifica", label: "Rettifica", icon: ShieldCheck },
  { id: "traduci", label: "Traduci", icon: Languages },
];

export default function AIPanel({ open, onClose, email, initialMode }) {
  const [mode, setMode] = useState(null);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const soloTraduci = initialMode === "traduci";

  const run = useCallback(async (m, em) => {
    if (!em) return;
    setMode(m);
    setLoading(true);
    setResult("");
    try {
      const r = await api.aiAction(m, em.corpo, em.oggetto);
      setResult(r);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "L'AI non è al momento disponibile");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (open) {
      setMode(null);
      setResult("");
      setLoading(false);
      if (initialMode && email) run(initialMode, email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, initialMode]);

  return (
    <div className={`wf-modal-backdrop ${open ? "show" : ""}`} onClick={onClose}>
      <div className="wf-modal" onClick={(e) => e.stopPropagation()} data-testid="ai-panel">
        <div className="wf-modal-head">
          <span className="wf-modal-title">
            {soloTraduci ? <><Languages size={19} strokeWidth={2.3} color="#2196e8" /> Traduzione</> : <><Sparkles size={19} strokeWidth={2.3} color="#2196e8" fill="#2196e8" /> AI</>}
          </span>
          <button className="icon-btn" onClick={onClose} aria-label="Chiudi" data-testid="ai-close">
            <X size={20} strokeWidth={2.6} />
          </button>
        </div>

        {email ? (
          <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 12 }}>
            Email: “{email.oggetto}” — {email.mittente}
          </div>
        ) : (
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: "var(--ink-soft)" }}>
            Nessuna email selezionata: apri un'email per usare l'AI.
          </div>
        )}

        {!soloTraduci && <div className="ai-actions">
          {MODES.map((m) => (
            <button
              key={m.id}
              className={`wf-btn ${mode === m.id ? "ai" : ""}`}
              onClick={() => run(m.id, email)}
              disabled={!email || loading}
              data-testid={`ai-${m.id}-btn`}
            >
              <m.icon size={16} strokeWidth={2.4} /> {m.label}
            </button>
          ))}
        </div>}

        {loading && (
          <div data-testid="ai-loading">
            <AiRagiona tipo={soloTraduci || mode === "traduci" ? "traduci" : mode === "errori" ? "errore" : "elabora"} />
          </div>
        )}

        {result && (
          <div className="ai-result" data-testid="ai-result">
            {result}
          </div>
        )}

        <div className="ai-note">Le risposte sono generate dall'AI in tempo reale.</div>
      </div>
    </div>
  );
}
